// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePrescriptionModel {
    static getAttributeTypeMap() {
        return SimpleIntakePrescriptionModel.attributeTypeMap;
    }
}
SimpleIntakePrescriptionModel.discriminator = undefined;
SimpleIntakePrescriptionModel.additionalProperties = false;
SimpleIntakePrescriptionModel.attributeTypeMap = [
    {
        "name": "ndcId",
        "baseName": "ndcId",
        "type": "number"
    },
    {
        "name": "writtenOn",
        "baseName": "writtenOn",
        "type": "Date"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "number"
    },
    {
        "name": "refills",
        "baseName": "refills",
        "type": "number"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "directions",
        "baseName": "directions",
        "type": "string"
    },
    {
        "name": "dispenseTypeId",
        "baseName": "dispenseTypeId",
        "type": "number"
    },
];
//# sourceMappingURL=simpleIntakePrescriptionModel.js.map